/* Native Shopify offer logic and page-local interactions for Magnesium sleep v2. */
(() => {
  document.querySelectorAll('[data-lp-mag2]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-l2-product]').textContent);
    const form = root.querySelector('.l2-form');
    const purchaseLinks = [...root.querySelectorAll('a[href="#l2-buy"]')];
    const mobilePurchase = matchMedia('(max-width: 899px)');
    const updatePurchaseLinks = () => purchaseLinks.forEach(link => {
      link.setAttribute('href', mobilePurchase.matches ? `#${form.getAttribute('id')}` : '#l2-buy');
    });
    updatePurchaseLinks();
    mobilePurchase.addEventListener('change', updatePurchaseLinks);
    const variantSelect = root.querySelector('[data-l2-variant]');
    const options = Object.fromEntries([...root.querySelectorAll('[data-l2-option]')].map(input => [input.value, input]));
    const planInput = root.querySelector('[data-l2-plan]');
    const quantityInput = root.querySelector('[data-l2-quantity]');
    const addButton = root.querySelector('[data-l2-add]');
    const status = root.querySelector('[data-l2-status]');
    const cartLink = root.querySelector('[data-l2-cart-link]');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: data.currency});
    const money = cents => formatter.format(cents / 100);
    const getVariant = () => data.variants.find(variant => String(variant.id) === variantSelect.value);
    const allocation = variant => variant.allocations.find(plan => plan.id === data.plan90);
    let pending = false;
    let selection;
    if (data.variants.length === 1) {
      variantSelect.hidden = true;
      root.querySelector('.l2-variant-label').hidden = true;
    }
    // Match the reference's selected 3-month subscription when it is actually available.
    if (allocation(getVariant(), 'three')) options.three.checked = true;
    function update(clearStatus = false) {
      const variant = getVariant();
      const referencePrice = variant.compare > variant.price ? variant.compare : variant.price;
      options.three.disabled = !allocation(variant, 'three');
      options.once.disabled = variant.requiresPlan;
      let chosen = Object.values(options).find(input => input.checked);
      if (!chosen || chosen.disabled) {
        chosen = [options.three, options.once].find(input => !input.disabled);
        if (chosen) chosen.checked = true;
      }
      ['three'].forEach(name => {
        const plan = allocation(variant, name);
        const quantity = 1;
        const days = quantity * 90;
        const card = options[name].closest('.l2-offer-card');
        card.classList.toggle('l2-unavailable', !plan);
        const daily = root.querySelector(`[data-l2-daily="${name}"]`);
        root.querySelector(`[data-l2-billing="${name}"]`).textContent = plan ? `${money(plan.price * quantity)} every ${days} days` : 'Matching subscription plan unavailable';
        daily.textContent = plan ? money(plan.price / 90) : '—';
        const saving = root.querySelector(`[data-l2-saving="${name}"]`);
        saving.hidden = !plan || plan.price >= referencePrice;
        saving.textContent = plan && plan.price < referencePrice ? `SAVE ${Math.round((1 - plan.price / referencePrice) * 100)}%` : '';
        saving.setAttribute('aria-label', `${saving.textContent} versus ${money(referencePrice)} regular price`);
        root.querySelector(`[data-l2-shipping="${name}"]`).hidden = !plan || data.currency !== data.shopCurrency || data.shippingThreshold <= 0 || plan.price * quantity < data.shippingThreshold;
      });
      root.querySelector('[data-l2-once-price]').textContent = money(variant.price);
      root.querySelector('[data-l2-shipping="once"]').hidden = data.currency !== data.shopCurrency || data.shippingThreshold <= 0 || variant.price < data.shippingThreshold;
      const maxSaving = Math.max(0, Math.round((1 - variant.price / referencePrice) * 100), ...['three'].map(name => {
        const plan = allocation(variant, name);
        return plan ? Math.round((1 - plan.price / referencePrice) * 100) : 0;
      }));
      root.querySelector('[data-l2-sub-percent]').textContent = `${maxSaving}%`;
      root.querySelector('[data-l2-hero-offer]').textContent = maxSaving > 0 ? `Save up to ${maxSaving}%` : 'Choose your supply';
      root.querySelector('.l2-offer-banner').hidden = maxSaving <= 0;
      const name = chosen ? chosen.value : 'once';
      const quantity = 1;
      const plan = name === 'once' ? null : allocation(variant, name);
      const total = (plan ? plan.price : variant.price) * quantity;
      const compare = referencePrice * quantity > total ? referencePrice * quantity : 0;
      selection = {variant, quantity, plan, total, allowed: !!chosen};
      quantityInput.value = String(quantity);
      planInput.disabled = !plan;
      planInput.value = plan ? String(plan.id) : '';
      root.querySelector('[data-l2-summary]').textContent = plan ? `${money(total)} billed every ${quantity * 90} days · ${quantity * 90}-day supply` : `${money(total)} · one-time order · 90-day supply`;
      root.querySelector('[data-l2-terms]').textContent = plan ? `Subscriptions can pause or cancel anytime. ${money(total)} per delivery every ${quantity * 90} days.${plan.adjustments.length > 1 ? ' Later renewal pricing may differ; review checkout terms.' : ''}` : 'One-time purchase. No recurring charge.';
      addButton.disabled = pending || !variant.available || !chosen;
      root.querySelector('[data-l2-add-text]').textContent = pending ? 'ADDING…' : !variant.available ? 'SOLD OUT' : !chosen ? 'UNAVAILABLE' : `ADD TO CART — ${money(total)}`;
      const buttonCompare = root.querySelector('[data-l2-add-compare]');
      buttonCompare.hidden = pending || compare <= total;
      buttonCompare.textContent = money(compare);
      if (clearStatus) {status.textContent = ''; cartLink.hidden = true;}
    }
    form.addEventListener('change', () => update(true));
    update();
    async function addSelection(event) {
      event.preventDefault();
      if (pending || !selection.allowed || !selection.variant.available) return;
      const selected = selection;
      pending = true;
      status.textContent = '';
      cartLink.hidden = true;
      update();
      const item = {id: selected.variant.id, quantity: selected.quantity};
      if (selected.plan) item.selling_plan = selected.plan.id;
      try {
        const response = await fetch(data.cartAdd, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [item]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this selection. Please try again.');
        pending = false;
        update();
        const added = result.items && result.items[0];
        const actual = added && (added.final_line_price ?? added.line_price);
        status.textContent = `${selected.quantity} ${selected.quantity === 1 ? 'bottle' : 'bottles'} added${selected.plan ? ` with delivery every ${selected.quantity * 90} days` : ' as a one-time purchase'}.${typeof actual === 'number' ? ` Added product total: ${money(actual)}.` : ''} Review your cart for shipping, taxes and final discounts.`;
        cartLink.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      } catch (error) {
        pending = false;
        update();
        status.textContent = error.message || 'Unable to add to cart. Please try again.';
      }
    }
    addButton.addEventListener('click', addSelection);
    form.addEventListener('submit', addSelection);
    const gallery = root.querySelector('[data-l2-gallery]');
    const panels = [...gallery.children];
    let current = 0;
    function show(index) {
      current = (index + panels.length) % panels.length;
      gallery.scrollTo({left: panels[current].offsetLeft - panels[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      root.querySelector('[data-l2-gallery-status]').textContent = `${current + 1} / ${panels.length}`;
    }
    root.querySelector('[data-l2-prev]').addEventListener('click', () => show(current - 1));
    root.querySelector('[data-l2-next]').addEventListener('click', () => show(current + 1));
    gallery.addEventListener('scroll', () => {
      const stride = panels.length > 1 ? panels[1].offsetLeft - panels[0].offsetLeft : 1;
      current = Math.max(0, Math.min(panels.length - 1, Math.round(gallery.scrollLeft / stride)));
      root.querySelector('[data-l2-gallery-status]').textContent = `${current + 1} / ${panels.length}`;
    }, {passive: true});
    gallery.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const factsDialog = root.querySelector('#l2-facts');
    root.querySelector('[data-l2-facts-link]').addEventListener('click', event => {
      if (typeof factsDialog.showModal !== 'function') return;
      event.preventDefault();
      factsDialog.showModal();
    });
    root.querySelector('[data-l2-facts-close]').addEventListener('click', () => factsDialog.close());
    factsDialog.addEventListener('click', event => {
      if (event.target !== factsDialog) return;
      const bounds = factsDialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) factsDialog.close();
    });
    const dialog = root.querySelector('[data-l2-dialog]');
    const slot = root.querySelector('[data-l2-video-slot]');
    root.querySelectorAll('[data-l2-video]').forEach(link => link.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(link.dataset.l2Video)}?autoplay=1`;
      iframe.title = link.getAttribute('aria-label') || 'Pure Magnesium customer testimonial';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      slot.replaceChildren(iframe);
      dialog.showModal();
    }));
    root.querySelector('[data-l2-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => slot.replaceChildren());
    dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
    // A tall purchase column scrolls naturally, then stays pinned at its lower edge.
    const offer = root.querySelector('.l2-offer');
    const setOfferHeight = () => root.style.setProperty('--l2-offer-height', `${offer.offsetHeight}px`);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(setOfferHeight).observe(offer);
    setOfferHeight();
  });
})();
